import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import SavingStates from "../../constants/states/SavingStates";
import SpaceCreateViewStore from "../../stores/SpaceCreateViewStore";
import SpaceCreateView from "../views/SpaceCreateView";
import ImageUploaderStore from "../../stores/ImageUploaderStore";


class SpaceCreateContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "spaceCreateViewStoreState": SpaceCreateViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        };
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.spaceCreateViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SPACE_CREATE_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        this.imageUploaderStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.IMAGE_UPLOADER_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
        EventPublisher.unsubscribe(this.spaceCreateViewStoreSubscriber);
        EventPublisher.unsubscribe(this.imageUploaderStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.REST_IMAGE_STORE, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "spaceCreateViewStoreState": SpaceCreateViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        });
    };

    render() {
        return (
            <SpaceCreateView
                isSaving={this.state.spaceCreateViewStoreState.savingState === SavingStates.SAVING}
                googleAPILibReady={this.state.googleAPILibState.loadingState === LoadingStates.FINISHED_LOADING}
                title={this.state.spaceCreateViewStoreState.title}
                description={this.state.spaceCreateViewStoreState.description}
                price={this.state.spaceCreateViewStoreState.price}
                minimumDays={this.state.spaceCreateViewStoreState.minimumDays}
                spaceAddressGooglePlaceId={this.state.spaceCreateViewStoreState.spaceAddressGooglePlaceId}
                spaceAddressLatitude={this.state.spaceCreateViewStoreState.spaceAddressLatitude}
                spaceAddressLongitude={this.state.spaceCreateViewStoreState.spaceAddressLongitude}
                spaceAddress={this.state.spaceCreateViewStoreState.spaceAddress}
                showingImageSlideIndex={this.state.imageUploaderStore.currentShownImageIndex}
                imageNames={this.state.imageUploaderStore.imageNames}
                uploadPercentage={this.state.imageUploaderStore.currentUploadPercentage()}
            />
        );
    }

}

export default SpaceCreateContainer;